export default function npayValidate(
  state = { error: null, success: null, processing: "" },
  action
) {
  switch (action.type) {

    case 'VALIDATE_NPAY_SUCCESS':
      return {...state, ...{success: action.success,error:null}};
    case 'VALIDATE_NPAY_ERROR':
      return {...state, ...{error: action.error.response,success:null}};
    case 'RESET_VALIDATE_NPAY':
      return {...state, ...{success:null,error:null}};
    default:
      return state;
  }
}

